import { render, staticRenderFns } from "./PricingServiceItem.vue?vue&type=template&id=bd2abdae&scoped=true"
import script from "./PricingServiceItem.vue?vue&type=script&lang=js"
export * from "./PricingServiceItem.vue?vue&type=script&lang=js"
import style0 from "./PricingServiceItem.vue?vue&type=style&index=0&id=bd2abdae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2abdae",
  null
  
)

export default component.exports